import { render, staticRenderFns } from "./SliderV9.vue?vue&type=template&id=1b89fa07&"
import script from "./SliderV9.vue?vue&type=script&lang=js&"
export * from "./SliderV9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports